import type { ObservableOptions } from "soby"
import { Component } from "../types"

export const HtmlHidden = <T>(): ObservableOptions<T> => ({
    equals: (a: T, b: T) => {
        // Functions are compared by reference
        return a === b
    },
    type: Function,
    toHtml: (value) => undefined,
    fromHtml: (value) => undefined
})

export const HtmlChild = HtmlHidden<Component | undefined>()